import { PincodeDetails } from "../../domain/models/PincodeDetails";
import { PincodeDetailsDTO } from "../dto/pincode.dto";

export function adaptPincodeDetailsDtoToDomain(dto: PincodeDetailsDTO): PincodeDetails {
    return {
        wid: dto.wid,
        hasTAH: dto.hasTAH,
        hasStores: dto.hasStores,
        sid: dto.sid,
        message: dto.message,
    };
}